import { useState } from 'react';
import { createNotification } from './Functions';
import markImg from './assets/measurments/mark-m.svg';
import './mvTag.css';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const KEY = 'mv_newsletter';

// The footer sign-up. Each email reaches the admin panel's notifications
// (the same channel orders and failed payments use), so the team can add it
// to the mailing list.
export default function FooterNewsletter() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState(() => {
    try { return window.localStorage.getItem(KEY) ? 'done' : 'idle'; } catch { return 'idle'; }
  });
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    const value = email.trim().toLowerCase();
    if (!EMAIL_RE.test(value)) { setError('Enter an email like name@gmail.com.'); return; }
    setError('');
    setState('sending');
    try {
      await createNotification('newsletter', 'Newsletter sign-up', `${value} asked for new collections and offers by email.`, '', { email: value });
      try { window.localStorage.setItem(KEY, value); } catch { /* a reload may ask again */ }
      setState('done');
    } catch {
      setState('idle');
      setError('Could not sign you up just now. Please try again.');
    }
  };

  if (state === 'done') {
    return (
      <p className="fnl__done" role="status">
        <span className="fnl__tick" aria-hidden="true">✓</span>
        You are on the list. New collections and offers will reach your inbox.
      </p>
    );
  }

  return (
    <form className="fnl" onSubmit={submit} noValidate>
      <label className="fnl__field">
        <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M3 6l9 7 9-7" fill="none" stroke="currentColor" strokeWidth="1.6" /></svg>
        <input
          type="email"
          inputMode="email"
          autoComplete="email"
          aria-label="Your email address"
          placeholder="Your email address"
          value={email}
          onChange={(e) => { setEmail(e.target.value); if (error) setError(''); }}
          aria-invalid={error ? true : undefined}
        />
      </label>
      <button type="submit" className="mv-tag fnl__tag" disabled={state === 'sending'}>
        <span className="mv-tag__mark" style={{ '--mark': `url(${markImg})` }} aria-hidden="true"><i /></span>
        <span className="mv-tag__label">{state === 'sending' ? 'Joining…' : 'Subscribe'}</span>
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12H19M13 6L19 12L13 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>
      {error && <p className="fnl__error" role="alert">{error}</p>}
    </form>
  );
}
